import { render, staticRenderFns } from "./DocumentStatusEdit.vue?vue&type=template&id=eb6597ec&scoped=true"
import script from "./DocumentStatusEdit.vue?vue&type=script&lang=js"
export * from "./DocumentStatusEdit.vue?vue&type=script&lang=js"
import style0 from "./DocumentStatusEdit.vue?vue&type=style&index=0&id=eb6597ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb6597ec",
  null
  
)

export default component.exports